import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

export default (rootReducer, rootSaga) => {
  const middleware = [];
  const enhancers = [];

  // Saga
  const sagaMiddleware = createSagaMiddleware();
  middleware.push(sagaMiddleware);

  // Push middlewares
  enhancers.push(applyMiddleware(...middleware));

  const store = createStore(rootReducer, applyMiddleware(...middleware));

  // kick off root saga
  sagaMiddleware.run(rootSaga);

  return store;
};
